import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { NCABalance } from '@/api/rest/resources/types/ncaBalance';
import { UnitEnum } from '@/api/rest/resources/types/units';

import { isNullish } from '../booleans';

const kilogramsToTonnes = (kilograms: number) => {
  return kilograms / 1000;
};

export const formatFactKilogramsToTonnes = <T>(fact?: PlotReportFactElement<T>) => {
  if (isNullish(fact)) return fact;

  if (fact.unit === UnitEnum.kg || fact.unit === UnitEnum['kg/ha']) {
    return {
      ...fact,
      value: fact.value ? kilogramsToTonnes(Number(fact.value)) : fact.value,
      unit: fact.unit === UnitEnum.kg ? UnitEnum.t : UnitEnum['t/ha'],
    } as PlotReportFactElement<T>;
  }
  return fact;
};

export const formatBalanceKilogramsToTonnes = <T>(balance?: NCABalance<T>) => {
  if (!balance) return balance;

  if (balance.unit === UnitEnum.kg || balance.unit === UnitEnum['kg/ha']) {
    return {
      ...balance,
      value: balance.value ? kilogramsToTonnes(Number(balance.value)) : balance.value,
      unit: balance.unit === UnitEnum.kg ? UnitEnum.t : UnitEnum['t/ha'],
    } as NCABalance<T>;
  }
  return balance;
};

export const valueToTonne = (fromValue?: number | null, fromUnit?: string) => {
  if (!fromValue) return fromValue;

  if (fromUnit === UnitEnum.kg || fromUnit === UnitEnum['kg/ha']) {
    return kilogramsToTonnes(fromValue);
  }
  return fromValue;
};

export const unitToTonne = (unit: UnitEnum) => {
  switch (unit) {
    case UnitEnum.kg:
      return UnitEnum.t;
    case UnitEnum['kg/ha']:
      return UnitEnum['t/ha'];
    default:
      return unit;
  }
};
